export class EnvHolder {
    static standalone: boolean = false;
}